import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { parseCosmeticTypeIcon } from './utils';
import { parseCosmeticType } from 'src/Pages/MarketplaceV2/Components/MarketCosmetic/utils';

const CosmeticTypeCard = ({
  className,
  itemType
}) => {
  const imgSrc = parseCosmeticTypeIcon(itemType);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.container)
  }, imgSrc && /*#__PURE__*/React.createElement("img", {
    src: imgSrc,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Items Kind"), /*#__PURE__*/React.createElement("span", {
    className: styles.type
  }, parseCosmeticType(itemType))));
};

export default CosmeticTypeCard;